module.exports = __webpack_public_path__ + "media/images/blog-list-pic1-091fa9708cd54e2cd5070f8a3e72e3b2.png";